import './reader.sass'
import {ReactComponent} from '../../../app'
import {Html5Qrcode} from 'html5-qrcode'
import {Button} from 'antd'
import React from 'react'
import {LeftOutlined} from '@ant-design/icons'

export default class Reader extends ReactComponent {
  reader = null
  state = {
    active: false,
    torch: false,
    onClose: (res) => {
    },
    isTorch: false
  }

  async componentDidMount() {

    const {onClose} = this.props

    await this.updateState({onClose})

    this.isTorchDevice()

  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(prevProps.active !== this.props.active && this.props.active === true) {
      void this.loadQRCode()
    }
  }

  async toggleTorch() {
    //if(!scanning) return

    await this.reader.applyVideoConstraints({
      torch: !this.state.torch,
      advanced: [
        {
          torch: !this.state.torch
        }
      ]
    })

    void this.updateState({torch: !this.state.torch})
  }

  isTorchDevice() {
    const { torch: isTorch } = navigator.mediaDevices.getSupportedConstraints()

    void this.updateState({isTorch: !!isTorch})
  }

  async loadQRCode() {
    this.reader = new Html5Qrcode('reader-scanner')

    try {

      //event.preventDefault()

      //if(scanning) return

      //$reader.addClass('active')
      //$(document.body).addClass('reader-open')

      await this.reader.start({
        facingMode: 'environment'
      }, {
        fps: 10,
        qrbox: {
          width: 200,
          height: 200
        }
      }, (result) => {

        this.reader.stop()

        this.state.onClose(result)

      })

      this.reader.getRunningTrackSettings()

    } catch (error) {

      console.log(error)

    }
  }

  render() {
    return (
      <>

        {
          this.props.active &&

          <div id="reader-app" className={`${this.props.active ? 'active' : ''}`}>
            <div className="reader-header _background-secondary">
              <Button
                id="reader-close"
                type="text"
                className="btn-cancel"
                icon={<LeftOutlined/>}
                onClick={() => {
                  this.props.onClose(null)
                }}
              >Zpět</Button>
            </div>
            <div className="reader-content">
              <h4 className="reader-title">Naskenujte QR kód z účtenky</h4>

                {this.state.isTorch &&
                  <div className="mt-2">
                    <Button
                      onClick={() => {
                        void this.toggleTorch()
                      }}
                      id="reader-torch"
                      className={this.state.torch ? "active" : ""}
                      type="primary"
                      size="small"
                      icon={<svg xmlns="http://www.w3.org/2000/svg" height="26" viewBox="0 -960 960 960" width="26"
                                 fill="none">
                        <path
                          d="m226-640-86-84 56-58 86 86-56 56Zm214-120v-120h80v120h-80Zm296 120-58-56 86-84 56 56-84 84ZM360-80v-200L240-400v-200h480v200L600-280v200H360Zm80-80h80v-153l120-120v-87H320v87l120 120v153Zm40-180Z"
                          fill="var(--_primary-hex)"/>
                      </svg>
                      }>Světlo</Button>
                  </div>
                }

              <div id="reader-scanner"></div>
            </div>
          </div>
        }
      </>
    )
  }
}